/* Import Module */
import $ from "jquery";
import { isShow } from "../variables";
import { autoscroll } from "./anchor";

/* Define Script */
export const toggleLoading = async () => {
  switch (true) {
    case isShow.initDisplay:
      break;
    case isShow.loading:
      isShow.display = false;
      $("#loading").css("display", "table");
      break;
    case !isShow.loading:
      isShow.display = true;
      await new Promise((resolve) => setTimeout(resolve, 500));
      $("#loading").fadeOut(1000);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      await autoscroll();
      break;
  }
};
